(function () {
  'use strict';

  /*
   * Two corrections to how Skio prices its purchase options:
   *
   * 1. Skio renders a struck-through compare price on the one-time option even
   *    when it equals the price, giving "$29.00 $29.00". Hide it unless the
   *    compare is genuinely higher.
   *
   * 2. Skio renders no compare price at all on the subscription option, so the
   *    saving isn't visible next to it -- just "$26.10" with nothing to compare
   *    against. Show the one-time price struck through beside it.
   *
   * Skio re-renders the group on variant and purchase-type changes, so this
   * re-runs on mutation. Writes are skipped when the value is already correct,
   * so the observer settles instead of looping.
   */

  var ROW = '.skio-group-container';
  var COMPARE_CLASS = 'skio-compare-price';

  function toNumber(text) {
    var s = String(text || '').replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');
    if (lastComma > lastDot) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      s = s.replace(/,/g, '');
    }
    return parseFloat(s);
  }

  function priceWrap(row) {
    return row.querySelector('.skio-price');
  }

  function priceSpan(row) {
    var wrap = priceWrap(row);
    if (!wrap) return null;
    var spans = wrap.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      if (!spans[i].classList.contains(COMPARE_CLASS)) return spans[i];
    }
    return null;
  }

  function isOneTime(row) {
    var input = row.querySelector('input.skio-group-input');
    return !!input && /one-?time/i.test(input.id || '');
  }

  function apply() {
    var rows = [].slice.call(document.querySelectorAll(ROW));
    if (!rows.length) return;

    var baseText = null;
    var baseValue = NaN;
    for (var i = 0; i < rows.length; i++) {
      if (!isOneTime(rows[i])) continue;
      var span = priceSpan(rows[i]);
      if (!span) continue;
      baseText = span.textContent.trim();
      baseValue = toNumber(baseText);
    }

    for (var j = 0; j < rows.length; j++) {
      var row = rows[j];
      var wrap = priceWrap(row);
      var own = priceSpan(row);
      if (!wrap || !own) continue;

      var compare = wrap.querySelector('.' + COMPARE_CLASS);
      var price = toNumber(own.textContent);

      if (isOneTime(row)) {
        // Only ever hide here -- never invent a saving on the base price.
        if (!compare) continue;
        var shown = toNumber(compare.textContent) > price;
        var next = shown ? '' : 'none';
        if (compare.style.display !== next) compare.style.display = next;
        continue;
      }

      // Subscription / prepaid rows: show the one-time price when it's higher.
      if (isNaN(baseValue) || isNaN(price) || baseValue <= price) {
        if (compare && compare.style.display !== 'none') compare.style.display = 'none';
        continue;
      }

      if (!compare) {
        compare = document.createElement('span');
        compare.className = COMPARE_CLASS;
        wrap.appendChild(compare);
      }
      if (compare.textContent.trim() !== baseText) compare.textContent = baseText;
      if (compare.style.display !== '') compare.style.display = '';
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      apply();
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
